import { messages } from './messages';
import { LabelsService } from '@services/labels/labels.service';
import { MitekCapture } from './mitek-capture';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ScriptService } from 'ngx-script-loader';
import { Injectable } from '@angular/core';
import { hints } from './hints';
import {
  MitekUpdateModel,
  MitekHintsModel,
  MitekMessagesModel,
  MitekDocType
} from '@models/mitek';

declare const mitekScienceSDK: any;

@Injectable({
  providedIn: 'root'
})
export class MitekService {
  constructor(
    private scriptService: ScriptService,
    private labelsService: LabelsService
  ) {}

  /**
   * avvia acquisizione del video selfie
   */
  takeSelfie(): Observable<MitekUpdateModel> {
    return this.loadSdk().pipe(switchMap(() => this.startCapture('SELFIE')));
  }

  /**
   * avvia acquisizione del documento
   */
  takeDocument(captureType: MitekDocType): Observable<MitekUpdateModel> {
    return this.loadSdk().pipe(switchMap(() => this.startCapture(captureType)));
  }

  /**
   * carica l'sdk mitek
   */
  private loadSdk(): Observable<boolean> {
    const url = './assets/scripts/mitek/mitek-science-sdk.js';

    return this.scriptService.loadScript(url).pipe(
      map(() => {
        if (!this.isSdkReady()) {
          throw new Error('Mitek SDK not loaded');
        }

        return true;
      })
    );
  }

  /**
   * stabilisce se l'sdk è stato caricato correttamente
   */
  private isSdkReady(): boolean {
    // eslint-disable-next-line no-underscore-dangle
    return !!mitekScienceSDK && mitekScienceSDK.__esModule;
  }

  /**
   * crea una nuova istanza di mitek e avvia il capture
   */
  private startCapture(
    captureType: MitekDocType
  ): Observable<MitekUpdateModel> {
    return new MitekCapture(mitekScienceSDK, {
      captureType,
      messages: this.getTranslatedMessages(),
      hints: this.getTranslatedHints()
    }).start();
  }

  /**
   * restituisce gli hints tradotti
   */
  private getTranslatedHints(): MitekHintsModel {
    const translatedHints: MitekHintsModel = {};

    Object.keys(hints).forEach(key => {
      const code = hints[key];
      const label = this.labelsService.getLabel(code);

      translatedHints[key] = label;
    });

    return translatedHints;
  }

  /**
   * restituisce i messaggi tradotti
   */
  private getTranslatedMessages(): MitekMessagesModel {
    const translatedMessages: MitekMessagesModel = {};

    Object.keys(messages).forEach(key => {
      const firstMessageCode = messages[key].firstMessage;
      const firstMessageLabel = this.labelsService.getLabel(firstMessageCode);

      const fourCornerMessageCode = messages[key].fourCornerMessage;
      const fourCornerMessageLabel = this.labelsService.getLabel(
        fourCornerMessageCode
      );

      translatedMessages[key] = {
        firstMessage: firstMessageLabel,
        fourCornerMessage: fourCornerMessageLabel
      };
    });

    return translatedMessages;
  }
}
